import {Form as AntForm} from 'antd';
import InputMask from 'react-input-mask';
import style from './style';
import { useEffect, useState } from 'react';

type ErrorType = {
    isError: boolean;
    message: string;
}
interface IInputCpf {
    name: string;
    label?: string;
    placeholder?: string;
    required?: boolean;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    error?: ErrorType;
    disabled?: boolean;
}

const InputCpf = (props: IInputCpf) => {
    const [disabled, setDisabled] = useState(false);
    useEffect(() => {
        if (props.disabled === true) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, []);
    return (
        <AntForm.Item
            name={props?.name ?? 'cpf'}
            label={props?.label ?? 'CPF'}
            rules={[{required: props.required}]}
            help={props.error?.isError && props.error.message}
        >
            <InputMask
                mask="999.999.999-99"
                style={{...style.cpf, borderColor: props.error?.isError ? '#FF0000' : '#D9D9D9', borderRadius: 8}}
                data-testid="input-cpf"
                placeholder={props?.placeholder ?? 'CPF'}
                disabled={disabled}
                onChange={props.onChange}
            />
        </AntForm.Item>
    );
};

export {InputCpf};
